<script>
  /* Executable code section of the program */
  //Tool importation
  import {
    temporalData,
    isModalCoordinatorsOn,
    isModalUpdate,
    isAlertOn,
    alertMessagge,
    isReloadNecessary,
    chatId,
  } from "../../apis/storage";
  import { postDocument, updateDocument, getCollection,createDocumentWithID } from "../../apis/APIS";
  import { sendInvitationEmail } from "../../apis/apisSendEmail";

  //Auxiliary variables
  let objData = {};
  let realTimeEvents = [];

  if ($isModalCoordinatorsOn) {
    objData.name = "";
    objData.surname = "";
    objData.country = "";
    objData.jobtittle = "";
    objData.department = "";
    objData.email = "";
    objData.password = "";
  }
  if ($isModalUpdate) {
    objData = $temporalData;
  }

  //Function to undisplay modal
  const undisplayModal = () => {
    $isModalCoordinatorsOn = false;
    $isModalUpdate = false;
  };
  //Function to display modal alert
  const displayAlert = () => {
    $isAlertOn = true;
  };

  const verifyData = async () => {
    if (
      objData.name === "" ||
      objData.surname == "" ||
      objData.country == "" ||
      objData.jobtittle == "" ||
      objData.department == "" ||
      objData.email == "" ||
      objData.password == ""
    ) {
      $alertMessagge = "Fields marked with this sign (*) cannot be left empty";
      displayAlert();
    } else {
      if ($isModalCoordinatorsOn) {
        objData.myChats = [];
        realTimeEvents = await getCollection("events");
        if (realTimeEvents.length>0) {
        realTimeEvents.forEach((element) => {
          objData.myChats.push({
            chatId: element.tittle,
            eventTittle: element.tittle,
            eventCountry: element.country,
            eventPoster: element.eventMultimedia.eventImgUrl,
          });
        });
        }
        objData.isLogged = false;
        objData.profileImgUrl = "";
        objData.pastEvents = [];
        objData.scheduledMeetings = [];
        objData.userRole = "coordinator";
        await postDocument("coordinators", objData)
          .then(async(result) => {
            createDocumentWithID("users", result.id,objData)
            await sendInvitationEmail(objData.email, "coordinator", objData).then(
              () => {
                $alertMessagge = "Coordinator created successfully`";
                $isReloadNecessary = true;
                displayAlert();
                $isModalCoordinatorsOn = false;
              }
            );
          })
          .catch(() => {
            $alertMessagge =
              "An error occurred while creating the coordinator.";
            displayAlert();
          });
      } else {
        updateDocument("coordinators", objData, objData.id)
          .then(() => {
            updateDocument("users", objData, objData.id)
            $alertMessagge = "Coordinator updated successfully";
            $isReloadNecessary = true;
            displayAlert();
          })
          .catch(() => {
            $alertMessagge =
              "An error occurred while updating the coordinator.";
            displayAlert();
          });
        $isModalUpdate = false;
      }
    }
  };

  export const createCoordinatorAndUser = async (objData) => {
  try {
    // First: create coordinator
    await createDocumentWithID("users", objData);

    // Second: create user
    await postDocument("coordinators", objData);

    // Third: send invitation email
    await sendInvitationEmail(objData.email, "coordinator", objData);

    // Success actions
    $alertMessagge = "Coordinator created successfully";
    $isReloadNecessary = true;
    displayAlert();
    $isModalCoordinatorsOn = false;

  } catch (error) {
    console.error("❌ Error during coordinator creation process:", error.message);
    $alertMessagge = "An error occurred while creating the coordinator.";
    displayAlert();
  }
};

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="sectionContainer">
  <div class="formContainer">
    <div class="headerForm">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="currentColor"
        class="bi bi-x-circle icon"
        viewBox="0 0 16 16"
        on:keypress={() => undisplayModal()}
        on:click={() => undisplayModal()}
      >
        <path
          d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
        />
        <path
          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
        />
      </svg>
    </div>
    <div class="bodyForm">
      {#if $isModalCoordinatorsOn}
        <h2>Add Coordinator</h2>
      {:else}
        <h2>Update Coordinator</h2>
      {/if}
      <div class="containerInputs">
        <div class="form-floating">
          <input
            type="text"
            class="form-control formInput"
            placeholder="Tittle Event"
            bind:value={objData.name}
          />
          <label for="floatingPassword">Name</label>
        </div>
        <div class="form-floating">
          <input
            type="text"
            class="form-control formInput"
            placeholder="Country"
            bind:value={objData.surname}
          />
          <label for="floatingPassword">Surname</label>
        </div>
        <div class="form-floating">
          <input
            type="text"
            class="form-control formInput"
            placeholder="Country"
            bind:value={objData.country}
          />
          <label for="floatingPassword">Country</label>
        </div>
        <div class="form-floating">
          <input
            type="text"
            class="form-control formInput"
            placeholder="Tittle Event"
            bind:value={objData.jobtittle}
          />
          <label for="floatingPassword">Jobtittle</label>
        </div>
        <div class="form-floating">
          <input
            type="text"
            class="form-control formInput"
            placeholder="Tittle Event"
            bind:value={objData.department}
          />
          <label for="floatingPassword">Department</label>
        </div>
        <div class="form-floating">
          <input
            type="text"
            class="form-control formInput"
            placeholder="Tittle Event"
            bind:value={objData.email}
          />
          <label for="floatingPassword">Email</label>
        </div>
        {#if $isModalCoordinatorsOn}
          <div class="form-floating">
            <input
              type="text"
              class="form-control formInput"
              placeholder="Tittle Event"
              bind:value={objData.password}
            />
            <label for="floatingPassword">Temporal Password</label>
          </div>
          {:else}
          <div class="form-floating">
            <input
              type="text"
              class="form-control formInput"
              placeholder="Tittle Event"
              disabled
              bind:value={objData.password}
            />
            <label for="floatingPassword">Temporal Password</label>
          </div>
        {/if}
      </div>
    </div>
    <div class="buttonsForm">
      <button class="actionBtn" on:click={() => undisplayModal()}>Close</button>
      {#if $isModalCoordinatorsOn}
        <button class="actionBtn addEventBtn" on:click={verifyData}
          >Add Coordinator</button
        >
      {:else}
        <button class="actionBtn addEventBtn" on:click={verifyData}
          >Update Coordinator</button
        >
      {/if}
    </div>
  </div>
</section>

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  .sectionContainer {
    position: fixed;
    top: 0;
    z-index: 888;
    width: 100%;
    height: auto;
    min-height: 160vh;
    background-color: rgba(0, 0, 0, 0.432);
    padding: 30px;
    display: flex;
    justify-content: center;
  }
  .formContainer {
    background-color: white;
    width: 70%;
    height: 80vh;
    padding: 50px;
  }
  .headerForm {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .icon:hover {
    cursor: pointer;
    color: red;
  }
  .containerInputs {
    display: flex;
    flex-wrap: wrap;
    margin: 15px 0;
    padding: 15px;
  }
  h2 {
    border-bottom: 1px solid gray;
    margin-bottom: 10px;
    padding: 15px 0;
  }
  .form-floating {
    margin: 5px 15px;
  }
  .formInput {
    width: 250px;
  }
  .buttonsForm {
    width: 100%;
    padding: 20px;
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid gray;
  }
  .actionBtn {
    width: 150px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 20px;
  }

  .addEventBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .formContainer {
      background-color: white;
      width: 90%;
      height: 70vh;
      padding: 30px;
    }
    .containerInputs {
      display: flex;
      flex-wrap: wrap;
      margin: 15px 0;
      padding: 15px;
    }
    h2 {
      border-bottom: 1px solid gray;
      margin-bottom: 10px;
      padding: 15px 0;
    }
    .form-floating {
      margin: 5px;
      width: 45%;
    }
    .formInput {
      width: 100%;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .sectionContainer {
      position: fixed;
      height: 90dvh;
    }
    .formContainer {
      background-color: white;
      width: 100%;
      height: 89vh;
      max-height: 90dvh;
      overflow: auto;
      padding: 15px;
    }
    .containerInputs {
      display: flex;
      flex-direction: column;
      margin: 10px 0;
      padding: 10px;
    }
    h2 {
      border-bottom: 1px solid gray;
      margin-bottom: 10px;
      padding: 15px 0;
    }
    .form-floating {
      margin: 5px 0;
      width: 100%;
    }
    .formInput {
      width: 100%;
    }
    .buttonsForm {
      width: 100%;
      padding: 20px;
      display: flex;
      justify-content: flex-end;
      border-top: 1px solid gray;
    }
    .actionBtn {
      width: 250px;
      border-radius: 12px;
      font-size: 16px;
      font-weight: 500;
      padding: 8px 16px;
      margin: 0 10px;
    }
  }
  /* End of the section */
</style>
